import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json';

// Acción para obtener los datos de agua salada de un nodo
export const aguaSaladaNodo = createAsyncThunk(
    'aguaSaladaNodo/getAguaSaladaNodo',
    async ({ lat, lon }) => {
        try {
            const response = await axios.get("/api/sensor/getAguaSaladaNodo", {
                params: {
                    lat,
                    lon
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);